<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <base-card class="h-full">
          <v-card-text>
            <div class="d-flex justify-space-between align-center">
              <div class="card-title mb-0">
                {{ instances.length }} instances | {{ totalChannels }} channels
              </div>
              <v-btn
                color="primary"
                small
                dark
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-card-text>
        </base-card>
      </v-col>
      <v-col
        cols="12"
        md="8"
      >
        <base-card class="align-center">
          <v-card-text class="pa-0 pr-3">
            <div
              class="d-flex justify-space-between align-center flex-wrap"
            >
              <div>
                <v-toolbar
                  flat
                  class="pl-0"
                >
                  <v-text-field
                    v-model="search"
                    prepend-inner-icon="mdi mdi-magnify"
                    label="Search"
                    class="mx-0 pl-0 elevation-0"
                    dense
                    solo
                    hide-details
                    clearable
                    elevation="0"
                    style="min-width: 400px"
                  />
                </v-toolbar>
              </div>
              <div class="pa-lg-3 pa-sm-0">
                <v-btn
                  outlined
                  small
                  class="m-l-10"
                  @click="exportXLS()"
                >
                  <i class="mdi mdi-download p-r-5" />
                  Export
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        lg="3"
      >
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <base-card>
              <v-card-title>
                <div class="card-title mb-0">
                  Status
                </div>
              </v-card-title>
              <v-card-text>
                <div
                  v-for="(status, index) in statuses"
                  :key="index"
                  class="d-flex justify-space-between align-center"
                >
                  <div>
                    <v-checkbox
                      v-model="selectedStatuses"
                      class="ma-0 pa-0"
                      :value="status.title"
                      :label="status.title"
                    />
                  </div>
                  <div>
                    <v-chip
                      class="primary--text primary lighten-5"
                      label
                    >
                      <p class="font-weight-bold mb-0">
                        {{ status.count }}
                      </p>
                    </v-chip>
                  </div>
                </div>
              </v-card-text>
            </base-card>
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <base-card>
              <v-card-title>
                <div class="card-title mb-0">
                  Instances
                </div>
              </v-card-title>
              <v-card-text style="max-height: 400px; overflow-y: scroll;">
                <div
                  v-for="(instance, index) in instances"
                  :key="index"
                  class="d-flex justify-space-between align-center"
                >
                  <div>
                    <v-checkbox
                      v-model="selectedInstances"
                      class="ma-0 pa-0"
                      :value="instance.id"
                      :label="instance.name"
                    />
                  </div>
                  <div>
                    <v-chip
                      class="primary--text primary lighten-5"
                      label
                    >
                      <p class="font-weight-bold mb-0">
                        {{ instance.channels.length }}
                      </p>
                    </v-chip>
                  </div>
                </div>
              </v-card-text>
            </base-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        lg="9"
      >
        <div
          v-for="instance in filteredInstances"
          :key="instance.id"
          class="mb-4"
        >
          <v-row v-if="selectedInstances.includes(instance.id) && !isInstanceEmpty(instance)">
            <v-col class="font-weight-medium center">
              <span v-html="highlightMatches(instance.name)" /> (<span class="text-success">{{ activeChannelsCount(instance) }}</span>/{{ instance.channels.length }})
            </v-col>
            <v-col class="text-right">
              <v-tooltip
                v-for="admin in instance.admins"
                :key="admin.id"
                top
              >
                <template v-slot:activator="{on, attrs}">
                  <v-btn
                    fab
                    small
                    class="ma-0 pa-0"
                    v-on="on"
                    @click="openAdminPanel(admin)"
                  >
                    <img
                      style="min-width: 30px; width: 30px;"
                      :src="admin.avatar"
                      v-bind="attrs"
                      alt=""
                    >
                  </v-btn>
                </template>
                <span>{{ admin.username }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <base-card v-if="selectedInstances.includes(instance.id) && !isInstanceEmpty(instance)">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left"
                      style="width: 80px;"
                    >
                      ID
                    </th>
                    <th
                      class="text-left"
                      style="width: 90px;"
                    >
                      Logo
                    </th>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Started
                    </th>
                    <th class="text-left">
                      On Now
                    </th>
                    <th
                      class="text-left"
                      style="width: 100px;"
                    >
                      HLS3
                    </th>
                    <th style="width: 80px;" />
                  </tr>
                </thead>
                <tbody>
                  <template v-for="channel in instance.channels">
                    <tr
                      v-if="(selectedStatuses.includes('Active') && !channel.suspended) || (selectedStatuses.includes('Paused') && channel.suspended)"
                      :key="`channel` + channel.id"
                    >
                      <td
                        class="font-weight-medium text--disabled text-no-wrap text--pointer"
                        @click="goToDetails(channel)"
                        v-html="highlightMatches(channel.id)"
                      />
                      <td
                        class="text--pointer"
                        @click="goToDetails(channel)"
                      >
                        <v-img
                          height="35"
                          width="35"
                          class=" h-10 object-cover"
                          :src="channel.logoId ? 'https://playout006.noisypeak.com/api/v1/upload/' + channel.logoId + '?img.crop=50x50' : defaultIcon"
                        />
                      </td>
                      <td
                        class="font-weight-medium text--pointer"
                        @click="goToDetails(channel)"
                        v-html="highlightMatches(channel.name)"
                      />
                      <td class="text-no-wrap text--disabled">
                        {{ moment.utc(channel.createTime).format('D MMM YYYY') }}
                      </td>
                      <td>
                        <div
                          v-if="channel.suspended"
                          class="d-flex align-center"
                        >
                          <v-sheet
                            width="20"
                            height="20"
                            class="grey lighten-4 rounded-circle  d-flex  align-center justify-center mr-2"
                          >
                            <v-icon
                              class="primary--text text-caption"
                            >
                              mdi-pause
                            </v-icon>
                          </v-sheet>
                          <span>Paused</span>
                        </div>
                        <div
                          v-else-if="channelStatus(channel.id) !== 'ok'"
                          class="d-flex align-center"
                        >
                          <v-sheet
                            width="20"
                            height="20"
                            class="grey lighten-4 rounded-circle  d-flex  align-center justify-center mr-2"
                          >
                            <v-icon
                              class="error--text text-caption"
                            >
                              mdi-alert
                            </v-icon>
                          </v-sheet>
                          <span class="error--text">Error</span>
                        </div>
                        <div v-else>
                          <span class="font-weight-bold text--secondary text-caption">
                            {{ channel.current.name | truncate(22) }}
                          </span>
                          <v-progress-linear
                            v-model="channel.current.progress"
                            rounded
                            color="blue darken-1"
                          />
                        </div>
                      </td>
                      <td>
                        <v-btn
                          v-if="!channel.suspended"
                          class="mx-2 shadow-none orange darken-1"
                          fab
                          dark
                          x-small
                          @click="openPlayer(channel.streamURL, channel.name)"
                        >
                          <v-icon>mdi-play</v-icon>
                        </v-btn>
                      </td>
                      <td>
                        <v-menu
                          left
                          bottom
                        >
                          <template v-slot:activator="{on}">
                            <v-btn
                              icon
                              v-on="on"
                            >
                              <v-icon
                                class=""
                              >
                                mdi-dots-horizontal
                              </v-icon>
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item @click="togglePauseChannel(channel)">
                              <v-icon
                                v-if="!channel.suspended"
                                class="text-body-1 mr-2"
                              >
                                mdi-pause
                              </v-icon>
                              <v-icon
                                v-else
                                class="text-body-1 mr-2"
                              >
                                mdi-play
                              </v-icon>
                              <v-list-item-title>
                                <span v-if="channel.suspended">
                                  Start
                                </span>
                                <span v-else>
                                  Pause
                                </span>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click.stop="openRemoveDialog(item)">
                              <v-icon
                                class="text-body-1 mr-2"
                              >
                                mdi-trash-can
                              </v-icon>
                              <v-list-item-title>
                                Delete
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                    <v-expand-transition :key="`exp` + channel.name">
                      <tr
                        v-show="channel.expand"
                        style="background-color: #f5f5f5"
                      >
                        <td
                          colspan="8"
                          class="pa-4"
                        >
                          <span
                            class="font-weight-medium text--disabled text-no-wrap"
                          >HLS3 URL </span>
                          <span>
                            <a
                              :href="channel.streamURL"
                              target="_blank"
                              class="ma-0 font-weight-medium"
                              v-html="highlightMatches(channel.streamURL)"
                            />
                            <v-btn
                              class="m-l-10"
                              x-small
                              icon
                              @click.stop="handleCopy(channel.streamURL)"
                            >
                              <v-icon>
                                mdi-content-copy
                              </v-icon>
                            </v-btn>
                          </span>
                          <br>
                          <span
                            v-if="channel.xmltv"
                            class="font-weight-medium text--disabled text-no-wrap"
                          >EPG URL </span>
                          <span>
                            <a
                              :href="channel.xmltv.resultURLAuto"
                              target="_blank"
                              class="ma-0 font-weight-medium"
                              v-html="highlightMatches(channel.xmltv.resultURLAuto)"
                            />
                            <v-btn
                              class="m-l-10"
                              x-small
                              icon
                              @click.stop="handleCopy(channel.xmltv.resultURLAuto)"
                            >
                              <v-icon>
                                mdi-content-copy
                              </v-icon>
                            </v-btn>
                          </span>
                        </td>
                      </tr>
                    </v-expand-transition>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </base-card>
        </div>
      </v-col>
    </v-row>
    <!-- Player -->
    <v-bottom-sheet
      v-model="playerDialog"
      max-width="960"
      inset
      @change="dialogChange()"
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="p-l-20 p-r-20">
                {{ playerTitle }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
  import { processUser, processChannel, processDistribution } from '@/store/converters'
  import { setClipboard } from '@/helpers/utils'
  import moment from 'moment-timezone'
  import config from '@/config'

  export default {
    name: 'Channels',

    data () {
      return {
        playerDialog: false,
        playerTitle: '',
        frameSrc: '',
        statuses: [
          {
            title: 'Active',
            count: 0,
          },
          {
            title: 'Paused',
            count: 0,
          },
        ],
        selectedStatuses: ['Active'],
        selectedInstances: [],
        channelStatuses: {},
        instances: [],
        totalChannels: 0,
        search: '',
        selected: [],
        removeDialog: false,
        expanded: false,
        rules: {
          nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length >= 3 && v.length <= 255) || 'Name must be between 3 and 255 characters',
          ],
        },
        polling: null,
        currentUnixTime: moment().utc().unix() * 1000,
        current: {},
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      defaultIcon () {
        return '/images/no_logo.jpeg'
      },
      // eslint-disable-next-line vue/return-in-computed-property
      filteredInstances () {
        if (!this.search) {
          return this.instances
        }
        if (this.search) {
          const searchTerm = this.search.toLowerCase()
          const filtered = []
          for (let i = 0; i < this.instances.length; i += 1) {
            let inc = false
            const instance = this.instances[i]
            if (instance.name.toLowerCase().includes(searchTerm)) {
              inc = true
            }
            for (let i = 0; i < instance.channels.length; i += 1) {
              const ch = instance.channels[i]
              if (ch.id == searchTerm) {
                inc = true
              }
              if (ch.name.toLowerCase().includes(searchTerm)) {
                inc = true
              }
              if (ch.streamURL.toLowerCase().includes(searchTerm)) {
                inc = true
              }
            }
            if (inc) {
              filtered.push(instance)
            }
          }
          return filtered
        }
      },
    },
    watch: {
      'playerDialog' (to, from) {
        if (to === false) {
          this.closePlayer()
        }
      },
    },
    created () {
      this.loadData(false)

      this.pollData()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      pollData () {
        this.polling = setInterval(() => {
          this.currentUnixTime = moment().utc().unix() * 1000
          this.getStatuses()
          this.getCurrent()
        }, 7000)
      },
      isInstanceEmpty (instance) {
        if (this.selectedStatuses.includes('Paused')) {
          return false
        }

        for (let i = 0; i < instance.channels.length; i += 1) {
          if (!instance.channels[i].suspended) {
            return false
          }
        }
        return true
      },
      activeChannelsCount (instance) {
        let count = 0
        for (let i = 0; i < instance.channels.length; i += 1) {
          if (!instance.channels[i].suspended) {
            count += 1
          }
        }
        return count
      },
      getStatuses () {
        const args = {}
        const statusesReq = this.$store.dispatch('channelStatuses', args)

        Promise.all([statusesReq])
          .then((res) => {
            const statuses = res[0]
            for (let i = 0; i < statuses.length; i += 1) {
              this.channelStatuses[statuses[i].Id] = statuses[i].Status
            }
          })
          .catch((errorMsg) => {
            console.log('error getting statuses', errorMsg)
          })
      },
      getCurrent () {
        const args = {}
        const currentReq = this.$store.dispatch('channelCurrentPrograms', args)

        Promise.all([currentReq])
          .then((res) => {
            const current = res[0]
            for (let i = 0; i < current.length; i += 1) {
              this.current[current[i].channel_id] = current[i]
            }
            for (let i = 0; i < this.filteredInstances.length; i += 1) {
              for (let j = 0; j < this.filteredInstances[i].channels.length; j += 1) {
                const ch = this.filteredInstances[i].channels[j]
                this.playedProgress(ch)
              }
            }
          })
          .catch((errorMsg) => {
            console.log('error getting current', errorMsg)
          })
      },
      playedProgress (channel) {
        if (channel.suspended) {
          channel.current.name = ''
          channel.current.progress = 0
          return
        }
        // eslint-disable-next-line no-prototype-builtins
        if (!this.current.hasOwnProperty(channel.id)) {
          channel.current.name = 'Blackout'
          channel.current.progress = 50
          return
        }
        const c = this.current[channel.id]
        const eventDuration = c.end * 1000 - c.start * 1000
        // eslint-disable-next-line no-mixed-operators
        const progress = (this.currentUnixTime - c.start * 1000) * 100 / eventDuration
        channel.current.name = c.name
        channel.current.progress = progress
      },
      channelStatus (id) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.channelStatuses.hasOwnProperty(id)) {
          return this.channelStatuses[id]
        }
        return 'ok'
      },
      highlightMatches (text) {
        if (!this.search) return text
        text += ''
        const matchExists = text.toLowerCase().includes(this.search.toLowerCase())
        if (!matchExists) return text
        const re = new RegExp(this.search, 'ig')
        return text.replace(re, (matchedText) => `<span class="orange--text">${matchedText}</span>`)
      },
      getAvatarImg (username) {
        const firstChar = username.substring(0, 1)
        if (firstChar <= 'i') {
          return require('@/assets/images/avatars/man-1.svg')
        }
        if (firstChar > 'i' && firstChar < 'r') {
          return require('@/assets/images/avatars/man-2.svg')
        }
        return require('@/assets/images/avatars/man-3.svg')
      },
      handleCopy (text) {
        setClipboard(text)
        this.$store.commit('showSnackbar', {
          text: 'Copied',
          timeout: 500,
          color: 'success',
          bottom: true,
        })
      },
      loadData (silent) {
        if (!silent) {
          this.$store.commit('setPageLoader')
        }

        const userReqArgs = {}
        const userReq = this.$store.dispatch('users', userReqArgs)

        const channelReqArgs = {
          $expand: 'instance',
        }
        const channelReq = this.$store.dispatch('channels', channelReqArgs)

        const distributionReqArgs = {
          'default[eq]': 1,
        }
        const distributionReq = this.$store.dispatch('distributions', distributionReqArgs)

        Promise.all([userReq, channelReq, distributionReq])
          .then((res) => {
            const users = res[0].map((u) => processUser(u))

            const channels = res[1].map((c) => processChannel(c))
            this.totalChannels = channels.length

            const response3 = res[2] || []
            const distributions = response3.map((d) => processDistribution(d))
            const distributionMap = {}
            for (let i = 0; i < distributions.length; i += 1) {
              const d = distributions[i]
              for (const key in d.urls) {
                if (key === 'hls3') {
                  distributionMap[d.channelId] = d.urls[key]
                }
              }
            }

            const instanceMap = {}
            let totalActive = 0
            for (let i = 0; i < channels.length; i += 1) {
              const ch = channels[i]
              ch.expand = false
              ch.state = ''
              ch.current = {
                name: '',
                progress: 0,
              }

              // eslint-disable-next-line no-prototype-builtins
              if (distributionMap.hasOwnProperty(ch.id)) {
                ch.streamURL = distributionMap[ch.id]
              } else {
                let streamURL = ch.streamURLhlsv3
                streamURL = streamURL.replace('$origin', 'now')
                streamURL = streamURL.replace('$offset', '-1m_15s')
                streamURL = streamURL.replace(',', '_')
                ch.streamURL = streamURL
              }

              ch.streamURL = ch.streamURL.replace('distrib010.noisypeak.com', 'distrib.noisypeak.com')

              // eslint-disable-next-line no-prototype-builtins
              if (!instanceMap.hasOwnProperty(ch.instance.id)) {
                instanceMap[ch.instance.id] = {
                  id: ch.instance.id,
                  name: ch.instance.name,
                  channels: [],
                  admins: [],
                }
                this.selectedInstances.push(ch.instance.id)
              }
              instanceMap[ch.instance.id].channels.push(ch)
              if (!ch.suspended) {
                totalActive += 1
              }
            }
            for (let i = 0; i < users.length; i += 1) {
              const user = users[i]
              // eslint-disable-next-line no-prototype-builtins
              if (instanceMap.hasOwnProperty(user.instanceId)) {
                user.avatar = this.getAvatarImg(user.username)
                instanceMap[user.instanceId].admins.push(user)
              }
            }
            for (let i = 0; i < this.statuses.length; i += 1) {
              const s = this.statuses[i]
              if (s.title === 'Active') {
                s.count = totalActive
              }
              if (s.title === 'Paused') {
                s.count = this.totalChannels - totalActive
              }
            }
            const instances = []
            for (const id in instanceMap) {
              instances.push(instanceMap[id])
            }
            this.instances = instances
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.getCurrent()
            this.$store.commit('resolvePageLoader')
          })
      },
      openPlayer (url, title) {
        this.setFrameSrc(url)
        this.playerDialog = true
        this.playerTitle = title
      },
      setFrameSrc (url) {
        const link = url.replace(/^http:\/\//, 'https://')
        this.frameSrc = `/js/radiant/index.html?src=${link}`
      },
      closePlayer () {
        this.playerDialog = false
        this.playerTitle = ''
        this.setFrameSrc('')
      },
      togglePauseChannel (ch) {
        if (ch.suspended) {
          return
        }
        const channel = {
          id: ch.id,
          suspended: true,
        }
        this.$store.dispatch('updateChannel', channel)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The channel "' + ch.name + '" has been successfully paused',
              timeout: 3000,
              color: 'success',
            })
            ch.suspended = true
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.isSaving = false
            this.$store.commit('resolvePageLoader')
          })
      },
      exportXLS () {
        this.$store.dispatch('getChannelReport')
          .then((response) => {
            const blob = new Blob([response.data], { type: response.data.type })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'Playout Channels'
            link.click()
            URL.revokeObjectURL(link.href)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      openAdminPanel (user) {
        this.$store.dispatch('getUserToken', user.id)
          .then((res) => {
            if (res.data) {
              const url = `${config.ADMIN_PANEL}/pass-through/${res.data}`
              window.open(url, '_target')
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      goToDetails (channel) {
        this.$router.push({
          name: 'Channel',
          params: {
            channel_id: channel.id,
          },
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
